import { useMatches } from "react-router-dom";
import { isNative } from "../../common/utils/native.ts";

export interface HomeRouteHandle {
  sidebar?: boolean;
}

export function useIsSidebarEnabledForRoute(): boolean {
  const matches = useMatches();
  if (isNative()) {
    return false;
  }
  for (const match of matches) {
    // handles are by default unknown since they are permitted to wildly vary,
    // but I think it's a reasonable assumption they are either records or undefined
    const handle = match.handle as Record<string, unknown> | undefined;
    if (typeof handle?.sidebar === "boolean") {
      // Looks redundant, but will help catch an error if HomeRouteHandle changes in an incompatible way
      return (handle as HomeRouteHandle).sidebar!;
    }
  }
  return true;
}
